type HeaderTypes = string;
type HeaderValues =
  | string
  | string[]
  | number
  | boolean
  | Record<string, unknown>;

const buildFilterQueryParams = (entry) => {
  const [key, filterObj] = entry;

  return Object.entries(filterObj)
    .filter(([, value]) => ['', null, undefined].every((e) => e !== value))
    .map(([k, v]) => `${key}[${k}]=${v}`);
};

const buildSortQueryParams = (entry) => {
  const [key, sortObj] = entry;

  return Object.entries(sortObj).map(([, v]) => `${key}[]=${v}`);
};

export const generateQueryParams = (
  obj: Record<HeaderTypes, HeaderValues>,
): string => {
  const queryArr = Object.entries(obj)
    .filter(([, value]) => ['', null, undefined].every((e) => e !== value))
    .map((entry) => {
      const [key] = entry;

      switch (key) {
        case 'filter':
          return buildFilterQueryParams(entry);

        case 'sort':
          return buildSortQueryParams(entry);

        default:
          return entry.join('=');
      }
    })
    .flat();

  if (queryArr.length === 0) {
    return '';
  }

  return encodeURI(`?${queryArr.join('&')}`);
};
